import {
  NOTE_MAIN_DATA,
  NOTE_MAIN_DATA_SUCCESS,
} from "./actionTypes";

const initialState = {
  notifications: [],
};

const CompareQuotation = (state = initialState, action) => {
  switch (action.type) {
    case NOTE_MAIN_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case NOTE_MAIN_DATA_SUCCESS:
      state = {
        ...state,
        notifications: action.payload,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};
export default CompareQuotation;
